<template>
  <div v-if="isCurrentUserDealer && imageExists" class="container-fluid section-items banner-container d-none d-sm-none d-md-block">
    <div class="container">
      <div class="row">
        <img :class="{
          'banner-img_pointer': link
        }" @click="openBannerLink" class="banner-img" alt="Main page banner" :src="imgSrc"/>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {base_url} from "@/lib/axios";
import {MAIN_PAGE_BANNER} from "@/config/common_image_codes";
import router from "@/router";
import {mapGetters} from "vuex";

export default {
  name: "Banner",
  data: () => ({
    link: '',
    imageExists: true,
    isLoading: false,
    imageLoadPromise: null
  }),
  async mounted() {
    try {
      this.isLoading = true;
      const {data: {status, data}} = await api.banner.getBanner(MAIN_PAGE_BANNER, this.currentBrand);

      if (status === 'ok' && data.link) {
        this.link = data.link;
      }

      // Загружаем изображение и проверяем его существование
      await this.loadAndCheckImage();
    } catch (error) {
      console.error('Error loading banner:', error);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    openBannerLink() {
      if ((new RegExp("^(?!www\\.|(?:http|ftp)s?://|[A-Za-z]:\\\\|//).*").test(this.link))) {
        router.push(this.link)
      } else {
        window.open(this.link, '_blank');
      }
    },

    loadAndCheckImage() {
      if (this.imageLoadPromise) {
        console.debug("imageLoadPromise")
      }

      this.imageLoadPromise = new Promise((resolve, reject) => {
        const img = new Image();
        const imageUrl = this.imgSrc;

        img.onload = () => {
          this.imageExists = true;
          resolve(true);
        };

        img.onerror = () => {
          this.imageExists = false;
          reject(new Error(`Failed to load image: ${imageUrl}`));
        };

        img.src = imageUrl;

        setTimeout(() => {
          if (!img.complete) {
            img.src = '';
            reject(new Error('Image loading timeout'));
          }
        }, 10000);
      });

      return this.imageLoadPromise.catch(error => {
        console.error('Image loading error:', error);
        this.imageExists = false;
        return false;
      });
    }
  },
  computed: {
    ...mapGetters("account", ["brandInfo"]),
    currentBrand() {
      let value = 1;

      if (this.brandInfo.currentBrand) {
        value = this.brandInfo.currentBrand
      } else {
        value = 1
      }

      return value;
    },
    imgSrc() {
      return `${base_url}/api/common-images/${MAIN_PAGE_BANNER}?brand=${this.currentBrand}`;
    }
  },
  watch: {
    currentBrand: {
      immediate: true,
      async handler(newBrand) {
        try {
          this.isLoading = true;
          const {data: {status, data}} = await api.banner.getBanner(MAIN_PAGE_BANNER, newBrand);

          if (status === 'ok' && data.link) {
            this.link = data.link;
          } else {
            this.link = '';
          }

          await this.loadAndCheckImage();
        } catch (error) {
          console.error('Error loading banner for brand change:', error);
          this.link = '';
        } finally {
          this.isLoading = false;
        }
      }
    }
  }
}
</script>

<style scoped>
.banner-container {
  margin-top: 1.88rem;
}

.banner-img_pointer {
  cursor: pointer;
}

.row {
  justify-content: center;
}
</style>